import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import CloseIcon from '../../layouts/SVG/CloseIcon';

const BlacklistDeleteConfirmModel = ({ show, onClose, onConfirm, phoneNumber }) => {
  return (
    <Modal className="modal-delete" show={show} onHide={onClose} centered>
      <Modal.Body>
        <CloseIcon handleModalClose={onClose} />

        <Modal.Title as="h4" style={{ margin: '16px 0 8px' }}>
          Remove from Blacklist
        </Modal.Title>
        <p>
          Are you sure you want to remove this number from the blacklist? This action cannot be
          undone.
          <br />
          <ul>
            <li>
              <strong>{phoneNumber}</strong>
            </li>
          </ul>
        </p>
        <div className="d-flex justify-content-right" style={{ marginTop: 24, gap: 16 }}>
          <Button variant="danger" onClick={onConfirm} style={{ minWidth: 160 }}>
            Confirm
          </Button>
          <Button variant="ghost" onClick={onClose} style={{ minWidth: 160 }}>
            Cancel
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BlacklistDeleteConfirmModel;
